import { ACC_CFG_PERIODS_ITEM } from './acc-cfg-periods.js'
import { ACC_CFG_MAPPINGS_ITEM } from './acc-cfg-mappings.js'
import { ACC_CFG_DEFAULTS_ITEM } from './acc-cfg-defaults.js'

/** @type {import('../help-index.js').HelpScreen} */
export const ACC_CFG_HELP = {
  screenId: 'acc-cfg',
  label: 'Configuración',
  navPath: 'Contabilidad → Configuración',
  keywords: [
    'plan de cuentas', 'mapeo contable', 'período contable', 'ejercicio', 'cuenta default',
    'instrumento', 'banco', 'caja',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Períodos del ejercicio, mapeo de cajas/bancos/POS y cuentas contables por defecto para generar asientos.',
  sidebarItems: [
    ACC_CFG_PERIODS_ITEM,
    ACC_CFG_MAPPINGS_ITEM,
    ACC_CFG_DEFAULTS_ITEM,
  ],
}
